import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextLink, PrismicNextImage } from "@prismicio/next";
import Arrow from '@/assets/images/icons/arrow-right.svg'
import ChevronDown  from '@/assets/images/icons/icon-chevron-down.svg'

/**
 * Props for `FeaturePanelsx3`.
 */
export type FeaturePanelsx3Props =
  SliceComponentProps<Content.FeaturePanelsx3Slice>;

/**
 * Component for "FeaturePanelsx3" Slices.
 */
const FeaturePanelsx3: FC<FeaturePanelsx3Props> = ({ slice }) => {

  const cleanImageUrl = (field: any) => {
    if (!field || !field.url) return field;
    const url = new URL(field.url);
    return {
      ...field,
      url: `${url.origin}${url.pathname}`
    };
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`font-fellix py-16 p-4  md:p-12 lg:p-16 ${slice.primary.grey_background === true ?  "bg-lightgrey" : ""}`}
    >
        <div className={"mb-8 max-w-7xl mx-auto"}>
          {slice.primary.heading ? <div className={`${slice.primary.center_text ? "text-center" : ""} mb-8`}>
          <PrismicRichText field={slice.primary.heading}/>
          </div>
          : <></>}
          <div className="grid grid-cols-12 max-w-7xl mx-auto gap-0 md:gap-8">
            {slice.primary.panels.map((item: any, index: number)=>{
                return (
                    <div className="col-span-12 md:col-span-4 mb-8 md:mb-0" key={index}>
                      {item.link.link_type !=="Any" ?
                        <PrismicNextLink field={item.link}>
                          <PrismicNextImage field = {cleanImageUrl(slice.primary.square_image === true ? item.image.sqare : item.image) } fallbackAlt="" className={`${slice.primary.square_image === true ? "aspect-square object-cover" : "aspect-5/4 object-contain"}  w-full`} sizes="(min-width: 1280px) 380px, (min-width: 768px) 33vw, 100vw" imgixParams={{ auto: ['compress'], fm: 'webp', q: 45, fit: 'max' }}/>
                          {slice.primary.text_order === true  ? <p className="mt-3 text-[14px]">{item.link_text}</p> : null }
                          <article className="prose prose-h2:text-[20px]! prose-h2:leading-6! md:prose-h2:text-[24px]! md:prose-h2:leading-7! prose-h3:text-[20px] prose-h3:leading-7 mt-5 mb-3">
                            <PrismicRichText field={item.title}/>
                          </article>
                          <article className="prose prose-h6:text-[14px] prose-h6:leading-[22px] prose-h5:text-[16px] prose-h5:leading-[22px]  prose-h5:font-semibold">
                          <PrismicRichText field={item.paragraph}/>
                          {slice.primary.text_order === false  ? <p>{item.link_text}<span className="inline-block"><ChevronDown className="rotate-270 h-5 w-[18px] stroke-blue relative top-1 left-1"/></span> </p> : null }
                          {item.link_style === true  ? <Arrow className="inline-block"/> : null}
                          </article>
                        </PrismicNextLink>
                      : 
                      <>
                        <PrismicNextImage field={cleanImageUrl(slice.primary.square_image === true ? item.image.sqare : item.image) } fallbackAlt="" className={`${slice.primary.square_image === true ? "aspect-square object-cover" : "aspect-5/4 object-contain"}  w-full`} sizes="(min-width: 1280px) 380px, (min-width: 768px) 33vw, 100vw" imgixParams={{ auto: ['compress'], fm: 'webp', q: 45, fit: 'max' }}/>
                          <article className="prose prose-h2:text-[20px]! prose-h2:leading-6! md:prose-h2:text-[24px]! md:prose-h2:leading-7! prose-h3:text-[20px] prose-h3:leading-7 mt-5 mb-3">
                            <PrismicRichText field={item.title}/>
                          </article>
                          <article className="prose prose-h6:text-[14px] prose-h6:leading-[22px] prose-h5:text-[16px] prose-h5:leading-[22px]  prose-h5:font-semibold pr-8">
                            <PrismicRichText field={item.paragraph}/>
                            {slice.primary.text_order === false  ? <p>{item.link_text}</p> : null }
                          </article>
                        </>}
                    </div>
                )
            })}
            </div>
        </div>
    </section>
  );
};

export default FeaturePanelsx3;
